import "./MainAbout.scss";
import { Link } from "react-router-dom";
import imgPrincipal from "../../assets/images/all/principal.png";

const MainAbout = () => (
  <section id="aboutUs">
    <div className="mainAbout">
      <div className="aboutHero">
        <div className="hero-left">
          <img
            src={imgPrincipal}
            alt="Sodalita Bem-Estar"
            className="single-image"
          />
        </div>

        <div className="hero-right">
          <h3>
            <strong>SOMOS ESPECIALISTAS EM PROGRAMAS DE BEM-ESTAR PARA EMPRESAS</strong>
          </h3>
          <p>
            Sabemos que um dos maiores desafios das empresas é garantir a adesão
            aos programas de bem-estar.
          </p>
          <p>
            Por isso, personalizamos cada atendimento conforme as necessidades e o
            perfil dos colaboradores, sempre alinhados às metas da empresa, à sua
            cultura e às diretrizes da nova NR-1 sobre riscos psicossociais.
          </p>
          <div className="result-block">
            {/* <p className="result-title">Resultado</p> */}
            <p className="result-body">
              Como resultado tenha maior engajamento com impacto real na saúde, no clima
              organizacional e nos resultados do negócio.
            </p>
          </div>
          <p>
            <Link to="/about" className="button primary">
              Saiba mais
            </Link>
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default MainAbout;
